module.exports = __webpack_public_path__ + "static/img/color.fd908a86.jpg";